import React from 'react';

export default function ImpactStats({ scannedItemsCount, totalChecks, totalEarnings, userBalance }) {
  return (
    <div className="mt-8 bg-gradient-to-br from-[#00D26A]/15 via-zinc-900 to-[#FFD700]/10 border border-zinc-800 rounded-lg p-8 text-white">
      <h3 className="text-2xl font-bold mb-4">
        Your <span className="text-[#FFD700]">Impact</span>
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div>
          <div className="text-3xl font-bold text-[#00D26A]" data-testid="items-scanned-count">{scannedItemsCount}</div>
          <div className="text-zinc-400 text-sm">Items Scanned</div>
        </div>
        <div>
          <div className="text-3xl font-bold text-[#00D26A]" data-testid="price-points-count">{totalChecks}</div>
          <div className="text-zinc-400 text-sm">Price Points Checked</div>
        </div>
        <div>
          <div className="text-3xl font-bold text-[#FFD700]" data-testid="total-earnings-display">£{totalEarnings.toFixed(2)}</div>
          <div className="text-zinc-400 text-sm">Earnings to Date</div>
        </div>
        <div>
          <div className="text-3xl font-bold text-[#FFD700]" data-testid="withdrawable-balance-display">£{userBalance.toFixed(2)}</div>
          <div className="text-zinc-400 text-sm">Withdrawable Balance</div>
        </div>
      </div>
      <p className="text-zinc-500 text-xs mt-6">
        Platform benchmarks: 107% profit uplift vs single-buyer · 875% ROI on subscription when using all 4 buyers.
      </p>
    </div>
  );
}
